export const RESTAURANT_VOUCHERS_URL = {
  getRestaurantVoucherDetailsUrl: (appId, restaurantVoucherId) =>
    `/${appId}/finance/restaurant-vouchers/${restaurantVoucherId}`,
  getAddNewRestaurantVoucherUrl: (appId) => `/${appId}/finance/restaurant-vouchers/new`,
};

export const RESTAURANT_VOUCHERS_MAX_LENGTH = 100;
